<template>
	<div class="pages">
		<el-pagination
		  background
		  layout="prev, pager, next"
		  :page-size="size"
		  :total="total"
		  :current-page.sync="mypage"
		  @current-change = "handleCurrentChange">
		</el-pagination>
	</div>
</template>

<script>
	export default{
		props: {
		  size: {
		    type: Number,
		    default: 10
		  },
		  page: {
		    type: Number,
		    default: 1
		  },
		  total: {
		    type: Number,
		    default: 0
		  }
		},
		data(){
			return{
				mypage:this.page
			}
		},
		methods: {
		  handleCurrentChange(val) {
		    this.$emit('current-change', val)
		  }
		}
	}
</script>

<style lang="less" scoped>
	.pages{
		margin-top: 50px;
		display: flex;
		float: right;
		height: 100px;
	}
</style>